var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "networks_list"
  }, _vm._l(_vm.networks, function (net) {
    return _c('NetworkRow', {
      key: net.id,
      staticClass: "network_row",
      attrs: {
        "network": net
      }
    });
  }), 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }